export enum EMedicalCategoryCategory {
  TREATMENT = 'TREATMENT',
  DEPARTMENT = 'DEPARTMENT',
}
export interface MedicalCategory {
  id: string;
  category: EMedicalCategoryCategory;
  name: string;
  iconUrl?: string;
}
export class MedicalCategoryModel {
  readonly id: string;
  readonly category: EMedicalCategoryCategory;
  readonly name: string;
  readonly iconUrl?: string;

  constructor({ _medicalCategory }: { _medicalCategory: MedicalCategory }) {
    this.id = _medicalCategory.id;
    this.category = _medicalCategory.category;
    this.name = _medicalCategory.name;
    this.iconUrl = _medicalCategory.iconUrl;
  }
}
